import { useEffect, useMemo, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { dataChart, noDataChart, options } from './config';

import styles from './doughnut-chart.module.css';

interface DoughnutChartProps {
  statusesData: Array<number>;
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({ statusesData }) => {
  const [chartData, setChartData] = useState(noDataChart);

  const result = useMemo(() => {
    return statusesData.reduce((acc, curr) => acc + curr, 0);
  }, [statusesData]);

  useEffect(() => {
    if (result) {
      setChartData({
        ...dataChart,
        datasets: [
          {
            ...dataChart.datasets[0],
            data: statusesData,
          },
        ],
      });
    }
  }, [result, statusesData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.total}>
        <div className={styles.text}>TOTAL</div>
        <div className={styles.result}>{result}</div>
      </div>
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default DoughnutChart;
